import React from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { Grid, Tooltip, IconButton, Stack, styled } from "@mui/material";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import colors from "assets/theme-dark/base/colors";
import { PhaseData } from "@/utils/MatcherProvider";

interface UnmatchHeaderProps {
  phaseData: PhaseData;
  selectedRows: string[];
  handleResultsView: () => void;
}

const UnmatchHeader: React.FC<UnmatchHeaderProps> = ({ phaseData, selectedRows, handleResultsView }) => {
  return (
    <MDBox>
      <Row justifyContent="space-between" sx={{ alignItems: "center" }}>
        <MDTypography variant="h3" mb={2}>
          Unmatch Data
        </MDTypography>
        <Tooltip title="Go to Results Page" arrow>
          <IconButton onClick={handleResultsView} sx={{ color: colors.secondary.main }}>
            <ArrowOutwardIcon fontSize="large" />
          </IconButton>
        </Tooltip>
      </Row>
      <MDBox mb={2}>
        <Grid container spacing={2}>
          {/* <Grid item>
            <MDTypography variant="body2">Total Records: {phaseData.totalRecords}</MDTypography>
          </Grid> */}
          <Grid item>
            <MDTypography variant="body2">Matched Count: {phaseData.matchedCount}</MDTypography>
          </Grid>
          <Grid item>
            <MDTypography variant="body2">Duplicate Count: {phaseData.duplicateCount}</MDTypography>
          </Grid>
          <Grid item>
            <MDTypography variant="body2">Selected: {selectedRows.length}</MDTypography>
          </Grid>
        </Grid>
      </MDBox>
    </MDBox>
  );
};

const Row = styled(Stack)`
  flex-direction: row;
  gap: 1rem;
`;

export default UnmatchHeader;
